import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Table, Button, Alert } from 'reactstrap';
import { getClientOffers } from '../../../../../../redux/actions/client';

const OfferData = ({ clientId }) => {
  const dispatch = useDispatch();
  const offerState = useSelector((state) => state.client.getOffers);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (clientId) {
      dispatch(getClientOffers(clientId));
    }
  }, [clientId, dispatch]);

  useEffect(() => {
    if (offerState) {
      setLoading(false);
      if (offerState.status === 'danger') {
        setError(offerState.message);
      } else {
        setError(null);
      }
    }
  }, [offerState]);

  const handleDownloadOffer = (pdf) => {
    window.open(pdf, '_blank');
  };

  if (loading) {
    return <div>Cargando ofertas...</div>;
  }

  return (
    <>
      <h4 className="mt-0">Ofertas</h4>

      {error && (
        <Alert color="danger">
          Error: {error || 'No se pudieron cargar las ofertas'}
        </Alert>
      )}

      {!error && (
        <Table responsive hover>
          <thead>
            <tr>
              <th>Nro de Oferta</th>
              <th>Versión</th>
              <th>Bien</th>
              <th>Precio</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {offerState.data && offerState.data.length > 0 ? (
              offerState.data.map((offer) => (
                <tr key={offer.id}>
                  <td>{offer.id || '--'}</td>
                  <td>{offer.data.version || '--'}</td>
                  <td>{offer.data.numerointerno || '--'}</td>
                  <td>
                    {offer.data.price
                      ? `$${offer.data.price.toLocaleString('es-CL')}`
                      : '--'}{' '}
                    {offer.data.iva}
                  </td>
                  <td>
                    <Button
                      color="primary"
                      size="sm"
                      onClick={() => handleDownloadOffer(offer.data.pdf)}
                    >
                      Descargar
                    </Button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" className="text-center">
                  No hay ofertas disponibles
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </>
  );
};

export default OfferData;
